import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ScreenHeader } from '../../components';
import { demoVideos } from '../../demo-components/wellness/demo-videos';
import WellnessCard from '../../demo-components/wellness/wellness-card';
import { useScrollToTop } from '../../hooks';

import '../../demo-components/wellness/videos-list.scss';

const VideosListPage = () => {
  const navigate = useNavigate();
  useScrollToTop();
  const [ activeTab, setActiveTab ] = useState('All');
  const [ hoveredCard, setHoveredCard ] = useState(null);

  const categories = [ 'All', 'Yoga', 'Exercise', 'Meditation', 'Sleep', 'Nutrition' ];

  const filteredVideos = activeTab === 'All' 
    ? demoVideos 
    : demoVideos.filter(video => 
      video.tags.some(tag => 
        tag.toLowerCase().includes(activeTab.toLowerCase())
      )
    );

  const handleVideoClick = (videoId: string) => {
    navigate(`/wellness/videos/${videoId}`);
  };

  const handleBack = () => {
    navigate('/wellness');
  };

  return (
    <div className="videos-list-page screen">
      <ScreenHeader
        title="All Videos"
        description="Explore our complete collection of health and wellness videos"
      />

      <div className="content">
        {/* Search */}
        <div className="search-container">
          <input 
            className="search-input"
            placeholder="Search videos..."
          />
          <svg className="search-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"/>
          </svg>
        </div>

        {/* Category Tabs */}
        <div className="category-tabs">
          {categories.map((category, index) => (
            <button
              key={index}
              className={`category-tab ${activeTab === category ? 'active' : ''}`}
              onClick={() => setActiveTab(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Section Header */}
        <div className="section-header">
          <div className="section-title">
            {activeTab === 'All' ? 'All Videos' : `${activeTab} Videos`} ({filteredVideos.length})
          </div>
          <span className="back-link" onClick={handleBack}>← Back to Wellness</span>
        </div>

        {/* Videos Grid */}
        <div className="videos-grid">
          {filteredVideos.map((video, index) => (
            <WellnessCard
              key={video.id}
              item={{
                id: video.id,
                title: video.title,
                subtitle: video.description.substring(0, 100) + '...',
                type: 'Video' as const,
                readTime: video.duration,
                image: '▶️'
              }}
              variant="featured"
              onClick={() => handleVideoClick(video.id)}
              onHover={(isHovered) => setHoveredCard(isHovered ? index : null)}
            />
          ))}
        </div>

        {/* Bottom spacing */}
        <div className="bottom-spacer"></div>
      </div>
    </div>
  );
};

export default VideosListPage;
